import * as z from "zod";

export const PartnerUserSummarySchema = z.object({
  id: z.string(),
  email: z.email(),
  name: z.string().nullable(),
  partner: z.object({ id: z.string(), name: z.string() }),
});

export type PartnerUserSummary = z.infer<typeof PartnerUserSummarySchema>;
